import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PropsTable = makeShortcode("PropsTable");
const PropsTableRow = makeShortcode("PropsTableRow");
const PropsTableSxRow = makeShortcode("PropsTableSxRow");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Deprecation`}</h2>
    <p>{`Use the new `}<a parentName="p" {...{
        "href": "/Label"
      }}>{`Label`}</a>{` instead.`}</p>
    <h2>{`Example`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live deprecated",
        "live": true,
        "deprecated": true
      }}>{`<>
  <Label variant="small" outline sx={{borderColor: 'danger.emphasis', mr: 2, color: 'danger.fg'}}>
    small
  </Label>
  <Label variant="medium" sx={{mr: 2}}>
    medium (default)
  </Label>
  <Label variant="large" sx={{mr: 2}}>
    large
  </Label>
  <Label variant="xl">xl label</Label>

  <Box mt={4} />
  <Label variant="medium" sx={{bg: '#A575FF', m: 1}}>
    good first issue
  </Label>
  <Label variant="medium" sx={{bg: '#FF75C8', m: 1}}>
    🚂 deploy: train
  </Label>
  <Label variant="medium" sx={{bg: '#1C90FA', m: 1}}>
    css
  </Label>
  <Label variant="medium" sx={{bg: '#FFF06C', color: '#24292E', m: 1}}>
    documentation
  </Label>
  <Label variant="medium" sx={{bg: '#656BFE', m: 1}}>
    primer
  </Label>
</>
`}</code></pre>
    <h2>{`Props`}</h2>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="outline" type="boolean" defaultValue="false" description="Creates an outline style label" mdxType="PropsTableRow" />
  <PropsTableRow name="variant" type="'small' | 'medium' | 'large' | 'xl'" defaultValue="'medium'" mdxType="PropsTableRow" />
  <PropsTableRow name="dropshadow" type="boolean" defaultValue="false" description="Adds a dropshadow to the label" mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: false,
      adaptsToThemes: true,
      adaptsToScreenSizes: false,
      fullTestCoverage: false,
      usedInProduction: false,
      usageExamplesDocumented: true,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      